/* global fetch */
/**
 * currency-rates-api.ts — lấy tỷ giá tự động thay cho nhập tay (VND là base).
 * Nguồn: open.er-api.com (ExchangeRate-API open endpoint) — miễn phí, không cần
 * API key, CORS mở, cập nhật ~hằng ngày. Response base=VND trả về
 * rates[CODE] = "1 VND đổi được bao nhiêu CODE" → rateToVnd = 1 / rates[CODE].
 */

export const CURRENCY_RATES_API_URL = "https://open.er-api.com/v6/latest/VND";

type ErApiResponse = {
  result?: string;
  rates?: Record<string, unknown>;
};

/** Parse + invert response (pure, tách riêng để unit-test không cần mock fetch). */
export function ratesToVndFromResponse(data: ErApiResponse, codes: string[]): Record<string, number> {
  if (data?.result !== "success" || !data.rates || typeof data.rates !== "object") {
    throw new Error("Malformed rates response");
  }
  const out: Record<string, number> = {};
  for (const raw of codes) {
    const code = raw.trim().toUpperCase();
    if (code === "VND") continue; // base — luôn là 1, không lưu
    const perVnd = data.rates[code];
    if (typeof perVnd === "number" && isFinite(perVnd) && perVnd > 0) {
      // 1 CODE = 1/perVnd VND; làm tròn 2 chữ số thập phân là quá đủ cho VND
      out[code] = Math.round((1 / perVnd) * 100) / 100;
    }
  }
  return out;
}

/**
 * Fetch tỷ giá → VND cho danh sách mã tiền tệ.
 * Trả về map { USD: 25405.5, ... } — mã không có trong nguồn bị bỏ qua.
 * Ném lỗi khi network/HTTP/response hỏng — caller hiển thị và GIỮ tỷ giá cũ.
 */
export async function fetchRatesToVnd(codes: string[]): Promise<Record<string, number>> {
  const res = await fetch(CURRENCY_RATES_API_URL);
  if (!res.ok) {
    throw new Error(`Rates API HTTP ${res.status}`);
  }
  const data = (await res.json()) as ErApiResponse;
  return ratesToVndFromResponse(data, codes);
}
